var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.9999 90C49.1299 90 37.4649 85.0925 26.2649 75.81C17.9424 68.91 12.8099 62.0825 12.5949 61.795L11.2574 60L12.5949 58.205C12.8099 57.9175 17.9424 51.0875 26.2649 44.19C37.4649 34.9075 49.1299 30 59.9999 30C70.8699 30 82.535 34.9075 93.7349 44.19C102.057 51.09 107.19 57.9175 107.405 58.205L108.742 60L107.405 61.795C107.19 62.0825 102.057 68.9125 93.7349 75.81C82.535 85.0925 70.8699 90 59.9999 90ZM18.8474 60C20.8574 62.4 24.8574 66.865 30.1974 71.2775C37.2224 77.0825 48.0975 84 59.9974 84C71.8974 84 82.7724 77.08 89.7974 71.2775C95.1375 66.865 99.1374 62.4 101.147 60C99.1374 57.6 95.1375 53.135 89.7974 48.7225C82.7724 42.9175 71.8974 36 59.9974 36C48.0975 36 37.2224 42.92 30.1974 48.7225C24.8574 53.135 20.8574 57.6 18.8474 60Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9999 78C50.0749 78 41.9999 69.925 41.9999 60C41.9999 50.075 50.0749 42 59.9999 42C69.9249 42 77.9999 50.075 77.9999 60C77.9999 69.925 69.9249 78 59.9999 78ZM59.9999 48C53.3824 48 47.9999 53.3825 47.9999 60C47.9999 66.6175 53.3824 72 59.9999 72C66.6174 72 71.9999 66.6175 71.9999 60C71.9999 53.3825 66.6174 48 59.9999 48Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/View.a536de6e.svg";
export { ForwardRef as ReactComponent };